<template>
  <div class="container">
    <!-- 轮播图 -->
    <el-carousel class="titleSwiper"
                 loop>
      <el-carousel-item v-for="item in banner"
                        :key="item.id">
        <div class="carouselBox">
          <div class="carouselBoxTitle">
            <p class="carouselBoxTitleHead">{{item.title}}</p>
            <p class="carouselBoxTitleText">{{item.info}}</p>
            <div class="carouselBoxTitleA"
                 @click="goAbout">了解更多</div>
          </div>
          <!-- <img class="carouselBoxImg" :src="item.img"  alt=""> -->
          <div class="carouselBoxLIttleImg"
               v-for="(littleImg, index) in item.img"
               :key="index">
            <img class=""
                 :src="littleImg.imgItem"
                 alt="">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 二层 -->
    <div class="titleTwo">
      <p v-show="twoTitleShow"
         class="titleTwoHead animate__animated animate__zoomIn  animate__slow-1 animate__repeat-1"
         ref="titleTwoHead">时空文化</p>
      <div class="titleTwoBox">
        <div class="titleTwoLeft">
          <div class="titleTwoLeftItem"
               v-for="item in twoList"
               :key="item.id">
            <div class="titleTwoLeftItemImgBox"><img class="titleTwoLeftItemImg"
                   v-lazy="item.titleImg"
                   :key="item.titleImg"
                   alt=""></div>
            <p class="titleTwoLeftItemHead">{{item.title}}</p>
            <p class="titleTwoLeftItemText">{{item.text}}</p>
            <img class="titleTwoLeftItemBack"
                 v-lazy="item.backImg"
                 :key="item.backImg"
                 alt="">
          </div>
        </div>
        <div class="titleTwoRight">
          <div class="titleTwoRightImgBox"><img class="titleTwoRightImg"
                 v-lazy="titleTwoImg1"
                 :key="titleTwo5"
                 alt=""></div>
          <p class="titleTwoRightHead">行为准则</p>
          <p class="titleTwoRightText">
            <span>聚焦</span>
            <span>创新</span>
            <span>提效</span>
            <span>健康</span>
          </p>
          <img class="titleTwoRightBack"
               v-lazy="titleTwo5"
               :key="titleTwo5"
               alt="">
        </div>
      </div>
    </div>
    <!-- 3层 -->
    <div class="three">
      <div class="threeBox">
        <div class="threeTop">
          <p class="threeTopOne">持续推动医药大健康产业数字经济转型</p>
          <p class="threeTopTwo">为客户提供更全面的数智化解决方案</p>
        </div>
        <div class="threeBottom"
             ref="obtain">
          <div class="threeBottomItem"
               v-for="(item, index) in threeList"
               :key="index">
            <div class="threeBottomItemT">
              <p class="threeBottomItemTL">
                <span v-show="!threeNumberShow">
                  {{item.number}}
                  <!-- <animate-number from="0" :to="item.number" :key="item.number" duration="2000"></animate-number> -->
                </span>
                <span v-if="threeNumberShow">
                  <!-- {{item.begin}} -->
                  <animate-number from="0"
                                  :to="item.number"
                                  :key="item.number"
                                  duration="3000"></animate-number>
                </span>
                <i>+</i>
                <span class="unit">{{item.unit}}</span>
              </p>
              <!-- <p class="threeBottomItemTR">{{item.unit}}</p> -->
            </div>
            <p class="threeBottomItemB">{{item.text}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 4层 -->
    <!-- <div class="four">
        <div class="fourBox">
            <p v-show="fourBoxTitleShow" class="fourBoxTitle animate__animated animate__zoomIn animate__slow-1 animate__repeat-1" ref="fourBoxTitle">时空产品</p>
            <div class="fourContent">
                <div class="fourContentLeft">
                    <p v-for="item in titleProduct" :key="item.ID" :class="indexFourList == item.ID?'pText':''" @click="onIndexFourList(item)">{{item.Name}}</p>
                </div>
                <div class="fourContentRight">
                    <ProductSwiper :products-list="titleProductList"/>
                </div>
            </div>
        </div>
    </div> -->
    <!-- 5层 -->
    <div ref="fiveBoxTopL">
      <pc-list v-show="fiveBoxTopLShow"
               :go-way='fiveWay'
               :title="fiveTitle"
               :list-left-one="headNews"
               :list-left-two="headNewsTwo"
               :list-right="headNewsL" />
    </div>
    <!-- <div class="five" v-show="fiveBoxTopLShow">
        <div class="fiveBox">
            <div class="fiveBoxTop">
                <p  class="fiveBoxTopL animate__animated animate__zoomIn  animate__slow-1 animate__repeat-1" ref="fiveBoxTopL">新闻中心</p>
            </div>
            <div class="fiveBoxBottom">
                <div class="fiveBoxBottomL" v-if="!headNewsShow">
                  <div class="fiveBoxBottomLItem"  @click="goNewsItem(headNews)">
                    <div class="fiveBoxBottomLItemImg">
                      <img v-lazy='headNews.TitlePic' :key="headNews.TitlePic" class="fiveBoxBottomLImg">
                    </div>
                    <div class="fiveBoxBottomLItemBox">
                      <p class="fiveBoxBottomLIcon"></p>
                      <p class="fiveBoxBottomLTitle">{{headNews.Title}}</p>
                      <p class="fiveBoxBottomLText">{{headNews.Info}}</p>
                    <img class="fourIcon" src="./index/pcHome/fourIcon.png" alt="">
                    </div>
                  </div>
                  <div class="fiveBoxBottomLItem fiveBoxBottomLItemFloat" @click="goNewsItem(headNewsTwo)">
                    <div class="fiveBoxBottomLItemImg">
                      <img v-lazy='headNewsTwo.TitlePic' :key="headNewsTwo.TitlePic" class="fiveBoxBottomLImg">
                    </div>

                    <div class="fiveBoxBottomLItemBox">
                      <p class="fiveBoxBottomLIcon"></p>
                      <p class="fiveBoxBottomLTitle" >{{headNewsTwo.Title}}</p>
                      <p class="fiveBoxBottomLText">{{headNewsTwo.Info}}</p>
                    <img class="fourIcon" src="./index/pcHome/fourIcon.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="fiveBoxBottomR" v-if="!headNewsShow" ref="fiveBoxBottomRItem">
                    <p class="fiveBoxBottomRBtn" @click="goNews">查看更多+</p>
                    <div v-show="fiveBoxBottomRItemHightShow" class="fiveBoxBottomRItem fiveBoxTopL animate__animated animate__slideInUp  animate__slow-1 animate__repeat-1" v-for="item in headNewsL" :key="item.ID" @click="goNewsItem(item)" >
                      <img v-lazy='item.TitlePic' class="fiveBoxBottomRImg" :key="item.TitlePic">
                    <div class="">
                      <p class="" >{{item.Title}}</p>
                    </div>
                    </div>
                </div>
                 
                <p class="headNewsShow" v-if="headNewsShow">
                  <img src="~@/assets/img/noContent.png" alt="" >
                </p>
            </div>
        </div>
    </div> -->
    <!-- 客户案例 -->
    <div ref="sixBoxTop">
      <pc-list v-show="sixBoxTopShow"
               :go-way='caseWay'
               :title="caseListTitle"
               :list-left-one="caseListLeftOne"
               :list-left-two="caseListLeftTwo"
               :list-right="caseListRight" />
    </div>

    <!-- 6层 -->
    <!-- <div class="six">
        <p class="sixTitle">众多行业领军企业选择郑州时空</p>
        <div class="sixBox">
          <MateMore   class="sixItem"/>
          <MateMoreTwo  class="sixItem"/>
          <MateMore  class="sixItem"/>
        </div>
    </div> -->
  </div>
</template>

<script>
import ProductSwiper from './components/pcSwiper/newSwiper.vue'
import MateMore from './components/pcSwiper/mateMore.vue'
import MateMoreTwo from './components/pcSwiper/mateMoreTwo.vue'
import PcList from './components/listBox/PcMyList.vue'
// 请求新闻
import { getArticle, getArticleApiHome } from '@/api/news'
// 引入获取解决方案类型
import { homeCustomer } from '@/api/client'
// 引入根路径
import request from '@/utils/request'
// import { baseImg } from '@/api/base'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
export default {
  name: 'PcHome',
  components: { MateMore, MateMoreTwo, ProductSwiper, PcList },
  data () {
    return {
      // 1层
      banner: [
        // { id: 1, title: '企业数智化整体解决方案服务商', info: '郑州时空成立于2002年，公司20多年来一直专注于以数字化、智能化推动企业进步，是国内领先的企业数智化整体解决方案服务商。', img: require('./index/pcHome/titlePc.png') },
        {
          id: 1,
          title: '企业数智化整体解决方案服务商',
          info: '郑州时空成立于2002年，公司20多年来一直专注于以数字化、智能化推动企业进步，是国内领先的企业数智化整体解决方案服务商。',
          img: [
            // {imgItem:require('./index/littleImg1.png')},
            { imgItem: require('./index/littleImg01.gif') },
            { imgItem: require('./index/littleImg02.gif') },
            { imgItem: require('./index/littleImg03.gif') },
            { imgItem: require('./index/littleImg04.gif') },
            { imgItem: require('./index/littleImg05.gif') },
            { imgItem: require('./index/littleImg06.gif') },
            { imgItem: require('./index/littleImg07.gif') },
            { imgItem: require('./index/littleImg08.gif') },
            { imgItem: require('./index/littleImg09.gif') },
            { imgItem: require('./index/littleImg10.gif') },
          ]
        },
        {
          id: 2,
          title: '智能仓储物流设备集成',
          info: '智能仓储物流设备集成、工业智能化设备等方面持续投入，为客户提供更全面的数智化解决方案，不断超越自我，追求卓越',
          img: [
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc21-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc22-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc23-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc24-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc25-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc26-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc27-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc28-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc29-safeimagekit.png') },
            { imgItem: require('./index/titlePc2-safeimagekit/titlePc210-safeimagekit.png') }
          ]
        }
      ],
      // 2层数据
      twoList: [
        { id: 1, title: '使命', titleImg: require('./index/pcHome/titleTwoImg1.png'), backImg: require('./index/pcHome/titleTwo4.png'), text: '以数智化推动企业进步' },
        { id: 2, title: '愿景', titleImg: require('./index/pcHome/titleTwoImg2.png'), backImg: require('./index/pcHome/titleTwo2.png'), text: '企业数智化整体解决方案服务商' },
        { id: 3, title: '经营目标', titleImg: require('./index/pcHome/titleTwoImg3.png'), backImg: require('./index/pcHome/titleTwo1.png'), text: '客户成功  员工成长  企业成就' },
        { id: 4, title: '服务理念', titleImg: require('./index/pcHome/titleTwoImg4.png'), backImg: require('./index/pcHome/titleTwo3.png'), text: '高效专业  提升价值' }
      ],
      titleTwoImg1: require('./index/pcHome/titleTwoImg1.png'),
      titleTwo5: require('./index/pcHome/titleTwo5.png'),
      twoTitleShow: false, // 开启标题动画
      // 3层数据
      threeList: [
        { number: 25, unit: '年', text: '行业经验', begin: 0 },
        { number: 55, unit: '家', text: '全国核心成员公司', begin: 0 },
        { number: 1000, unit: '人', text: '专业团队', begin: 0 },
        { number: 3, unit: '亿', text: '体系合并年产值', begin: 0 },
        { number: 6000, unit: '家', text: '医药公司客户', begin: 0 },
        { number: 8000, unit: '家', text: '零售药店', begin: 0 },
        { number: 300000, unit: '个', text: 'PC、移动端', begin: 0 },
        { number: 10, unit: '年', text: '市场占有率领先', begin: 0 }
      ],
      threeNumberShow: false, // 判断数字滚动
      // 4层数据
      fourList: [
        { title: '企业管理系统类', index: 'indexO' },
        { title: '仓储集成类', index: 'indexS' },
        { title: '工业智能类', index: 'indexT' }
      ],
      titleProductList: [], // 产品线子级
      indexFourList: 1, // 左侧标题index
      fourBoxTitleShow: false, // 标题动画
      //   5层数据
      fiveBoxTopLShow: false, // 标题动画
      fiveBoxBottomRItemHightShow: false, // 右边标题动画,
      fiveTitle: '新闻中心',
      fiveWay: 'newsItemNew',
      ItemIndex: 7, // 新闻选中index
      moreNewsList: [], // 更多新闻
      newsTitle: [], // 新闻分类
      newsTitleNew: [], // 新闻分类新
      headNews: {}, // 头部新闻左
      headNewsTwo: {},
      headNewsShow: false, // 展位图
      headNewsL: [], // 头部新闻右 
      //6客户案例
      sixBoxTopShow: false,  // 出现显示动画
      caseList: [],
      caseWay: 'caseShow',
      caseListLeftOne: {}, // 头部左
      caseListLeftTwo: {}, // 头部左
      caseListRight: [], // 右
      caseListTitle: '客户案例'
    }
  },
  watch: {
    titleProduct: {
      handler (v, o) {
        this.titleProductList = v[0].ProductsList
        this.indexFourList = v[0].ID
      },
      deep: true
    },
  },
  computed: {
    // 产品线
    titleProduct () {
      return this.$store.state.productTitle
    }
  },
  filters: {
    timeFormat
  },
  created () {
    // 调用获取新闻类型
    this.getArticle()
    this.getArticleApiHome(this.ItemIndex)
    this.homeCustomer()
  },
  mounted () {
    // 监听窗口滚动
    window.addEventListener('scroll', this.scrollTop)
    window.addEventListener('scroll', this.handleScrollx)
    // window.onresize = () => {
    //   // 屏幕尺寸变化
    //   return (() => {
    //     // this.screenWidth = document.body.clientWidth
    //     // this.handleScrollx()
    //   })()
    // }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollx)
    window.removeEventListener('scroll', this.scrollTop)
  },
  methods: {
    // 数字滚动
    scrollTop () {
    },
    goAbout () {
      this.$router.push('/aboutUs')
      this.activeIndex = '/aboutUs'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 页面滚动 添加标题动画
    handleScrollx () {
      // 2ceng
      const titleTwoHeadHight = window.innerHeight - (this.$refs.titleTwoHead.offsetTop - window.pageYOffset)
      if (titleTwoHeadHight > -5) {
        this.twoTitleShow = true
      } else {
        this.twoTitleShow = false
      }
      // 3层
      // 元素到底部距离
      const boxHight = window.innerHeight - (this.$refs.obtain.offsetTop - window.pageYOffset)
      // console.log(boxHight, '1')
      if (boxHight > 50) {
        this.threeNumberShow = true
      } else {
        this.threeNumberShow = false
      }
      //   4层
      // const fourBoxTitleHight = window.innerHeight - (this.$refs.fourBoxTitle.offsetTop - window.pageYOffset)
      // if (fourBoxTitleHight > -11) {
      //   this.fourBoxTitleShow = true
      // } else {
      //   this.fourBoxTitleShow = false
      // }
      // 5层 新闻中心
      const fiveBoxTopLHight = window.innerHeight - (this.$refs.fiveBoxTopL.offsetTop - window.pageYOffset)
      if (fiveBoxTopLHight > -11) {
        this.fiveBoxTopLShow = true
      } else {
        this.fiveBoxTopLShow = false
      }
      //   5选项列表
      // if (this.headNewsShow === false) {
      //   this.fiveBoxBottomRItemHightShow = true
      // }

      // 6层  客户案例
      const SixBoxTopLHight = window.innerHeight - (this.$refs.sixBoxTop.offsetTop - window.pageYOffset)
      // console.log('SixBoxTopLHight',SixBoxTopLHight)
      if (SixBoxTopLHight > -11) {
        this.sixBoxTopShow = true
      } else {
        this.sixBoxTopShow = false
      }
    },
    // 4层数据
    // 点击左侧标题
    onIndexFourList (item) {
      this.indexFourList = item.ID
      this.titleProductList = item.ProductsList
    },
    // 5层新闻
    // 获取新闻类型
    async getArticle () {
      const res = await getArticle()
      // console.log(res)
      if (res.Msg === '获取成功') {
        this.newsTitle = res.Data
        this.$store.commit('getNewsTitle', this.newsTitle)
      }
      this.newsTitleNew = this.newsTitle.slice(0, 4)
    },
    async getArticleApiHome (id) {
      this.ItemIndex = id
      const res = await getArticleApiHome({ TypeId: id })
      if (res.Msg === '获取成功') {
        this.moreNewsList = res.Data
        this.moreNewsList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic
        })
      }
      this.fiveBoxBottomRItemHightShow = true
      if (this.moreNewsList.length > 0) {
        this.headNews = this.moreNewsList.shift()
        this.headNewsTwo = this.moreNewsList.shift()
        this.headNewsL = this.moreNewsList.splice(0, 4)
        this.headNewsShow = false
      } else {
        this.headNewsShow = true
      }
    },
    goNewsItem (item) {
      // this.$router.push(newsItem)
      this.$router.push({ path: `/newsItemNew/${item.ID}` })
    },
    goNews () {
      this.$router.push({ path: '/newsCenter' })
    },
    // 客户案例
    async homeCustomer () {
      const res = await homeCustomer()
      // console.log(res, 'homeCustomerhomeCustomer')
      if (res.Msg === '获取成功') {
        this.caseList = res.Data
        this.caseList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic
        })
        if (this.caseList.length > 0) {
          this.caseListLeftOne = this.caseList.shift()
          this.caseListLeftTwo = this.caseList.shift()
          this.caseListRight = this.caseList.splice(0, 4)
        } else {
        }

      }
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  margin-top: 0;
}
// pc高度比
// $sun:75/192;
$sun: 100/192;
.titleSwiper {
  width: 1920px * $sun;
  height: 1080px * $sun;
}
::v-deep .el-carousel__container {
  width: 100%;
  height: 1080px * $sun;
}
.el-carousel {
  width: 100%;
  height: 1080px * $sun;
}

.el-carousel__item {
  width: 100%;
  height: 1080px * $sun;
}
// 轮播图item
.carouselBox {
  width: 100%;
  height: 1080px * $sun;
  position: relative;
}
// 轮播图图片
.carouselBoxImg {
  width: 100%;
  height: 1080px * $sun;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 970;
}
.carouselBoxLIttleImg {
  width: 100%;
  height: 108px * $sun;
  z-index: 970;
  img {
    width: 100%;
    height: 100%;
  }
}
// 轮播图中间文字
.carouselBoxTitle {
  width: 917px * $sun;
  height: 333px * $sun;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 980;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  .carouselBoxTitleHead {
    width: 100%;
    margin: 0;
    font-size: 62px * $sun;
    font-weight: 500;
  }
  .carouselBoxTitleText {
    font-size: 24px * $sun;
    line-height: 50px * $sun;
    letter-spacing: 2px * $sun;
    font-weight: 500;
  }
  .carouselBoxTitleA {
    width: 168px * $sun;
    height: 56px * $sun;
    background: #2380e1;
    color: #ffffff;
    font-size: 20px * $sun;
    border-radius: 6px * $sun;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 56px * $sun;
    font-weight: 500;
    cursor: pointer;
  }
}
// 二层
.titleTwo {
  width: 100%;
  height: 1000px * $sun;
  background: url("./index/pcHome/titleTwoB.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  // 2楼标题
  .titleTwoHead {
    width: 1400px * $sun;
    height: 50px * $sun;
    font-size: 36px * $sun;
    font-weight: 500;
    color: #252b3a;
    margin: 0 auto;
    margin-top: 40px * $sun;
  }
  // 2楼内容
  .titleTwoBox {
    width: 1400px * $sun;
    margin: 0 auto;
    margin-top: 40px * $sun;
    // margin-left: 260px*$sun;
    display: flex;
    justify-content: space-between;
    .titleTwoLeft {
      float: left;
      width: 1100px * $sun;
      height: 825px * $sun;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow: hidden;
      .titleTwoLeftItem {
        float: left;
        margin-right: 5px;
        margin-bottom: 14px;
        width: 540px * $sun;
        height: 398px * $sun;
        background: #252b3a;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        position: relative;
        .titleTwoLeftItemImgBox {
          margin: 0 auto;
          width: 30px * $sun;
          height: 30px * $sun;
          z-index: 500;
          opacity: 1 !important;
        }
        .titleTwoLeftItemImg {
          width: 30px * $sun;
          height: 30px * $sun;
          margin-bottom: 10px * $sun;
          z-index: 999;
          opacity: 1 !important;
        }
        .titleTwoLeftItemHead {
          width: 100%;
          text-align: center;
          font-size: 32px * $sun;
          margin-bottom: 10px * $sun;
          z-index: 10;
          opacity: 1 !important;
          font-weight: 500;
        }
        .titleTwoLeftItemText {
          width: 100%;
          text-align: center;
          font-size: 18px * $sun;
          z-index: 10;
          opacity: 1 !important;
          font-weight: 500;
        }
        .titleTwoLeftItemBack {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      // 鼠标经过
      .titleTwoLeftItem :hover {
        cursor: pointer;
        opacity: 0.5;
      }
    }
    .titleTwoRight {
      float: left;
      width: 292px * $sun;
      height: 824px * $sun;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      color: #fff;
      .titleTwoRightBack {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .titleTwoRightImgBox {
        width: 30px * $sun;
        height: 30px * $sun;
        margin: 0 auto;
        z-index: 500;
        opacity: 1 !important;
      }
      .titleTwoRightImg {
        width: 30px * $sun;
        height: 30px * $sun;
        margin-bottom: 10px * $sun;
        z-index: 10;
        opacity: 1 !important;
      }
      .titleTwoRightHead {
        width: 100%;
        text-align: center;
        font-size: 32px * $sun;
        margin-bottom: 10px * $sun;
        z-index: 10;
        opacity: 1 !important;
        font-weight: 500;
      }
      .titleTwoRightText {
        font-size: 18px * $sun;
        z-index: 10;
        width: 84px * $sun;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        opacity: 1 !important;
        font-weight: 500;
        span {
          margin-bottom: 20px * $sun;
          font-weight: 500;
        }
      }
    }
    // 鼠标经过
    .titleTwoRight :hover {
      cursor: pointer;
      opacity: 0.5;
    }
  }
}
// 3层
.three {
  width: 100%;
  height: 1000px * $sun;
  background: url("./index/pcHome/three.png") no-repeat;
  background-size: 100% 100%;
  color: #fff;
  overflow: hidden;
  margin-bottom: 120px * $sun;
  .threeBox {
    width: 1160px * $sun;
    height: 541px * $sun;
    margin: 0 auto;
    margin-top: 220px * $sun;
    // margin-top: 220px;
    .threeTop {
      width: 100%;
      height: 255px * $sun;
      text-align: center;
      .threeTopOne {
        font-size: 68px * $sun;
        margin-bottom: 26px * $sun;
        font-weight: 500;
      }
      .threeTopTwo {
        font-size: 32px * $sun;
        font-weight: 500;
      }
    }
    .threeBottom {
      width: 100%;
      height: 286px * $sun;
      .threeBottomItem {
        float: left;
        width: 241px * $sun;
        margin: 0 22px * $sun;
        margin-bottom: 80px * $sun;
        .threeBottomItemT {
          width: 241px * $sun;
          height: 73px * $sun;
          margin-bottom: 11px * $sun;
          text-align: center;
          .threeBottomItemTL {
            display: inline-block;
            font-size: 52px * $sun;
            margin: 0;
            margin-right: 18px * $sun;
            font-weight: 500;
            position: relative;
            i {
              position: absolute;
              top: 0;
              font-size: 20px * $sun;
            }
            .unit {
              position: absolute;
              right: -38px * $sun;
              bottom: 10px * $sun;
              font-size: 28px * $sun;
              font-weight: 500;
            }
          }
        }
        .threeBottomItemB {
          width: 176px * $sun;
          height: 30px * $sun;
          margin: 0 auto;
          text-align: center;
          font-size: 22px * $sun;
          font-weight: 500;
        }
      }
    }
  }
}
// 4层
.four {
  width: 100%;
  height: 1000px * $sun;
  background: #f6f9fe;
  display: flex;
  // justify-content: center;
  align-items: center;
  overflow: hidden;
  .fourBox {
    margin: 225px * $sun auto;
    width: 1384px * $sun;
    height: 550px * $sun;
    .fourBoxTitle {
      width: 100%;
      height: 90px * $sun;
      margin: 0;
      font-size: 36px * $sun;
      font-weight: 500;
    }
    .fourContent {
      width: 100%;
      height: 460px * $sun;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      .fourContentLeft {
        float: left;
        width: 235px * $sun;
        height: 460px * $sun;
        background: #fff;
        overflow-y: scroll;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        // padding: 74px*$sun 0;
        box-sizing: border-box;
        p {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 56px * $sun;
          font-size: 18px * $sun;
          cursor: pointer;
          border-radius: 4px * $sun;
          margin: 0;
          margin-bottom: 20px * $sun;
          margin-top: 20px * $sun;
          text-align: center;
          line-height: 56px * $sun;
          font-weight: 500;
        }
        .pText {
          background: #2380e1;
          color: #fff;
          height: 56px * $sun;
          font-size: 18px * $sun;
          cursor: pointer;
          border-radius: 4px * $sun;
          margin: 0;
          margin-bottom: 70px * $sun;
          margin-bottom: 20px * $sun;
          margin-top: 20px * $sun;
          text-align: center;
          // line-height: 36px*$sun;
          line-height: 56px * $sun;
        }
        p:hover {
          background: #2380e1;
          color: #fff;
        }
        -webkit-scrollbar {
          display: none;
        }
      }
      // 隐藏滚动条
      .fourContentLeft::-webkit-scrollbar {
        display: none;
      }
      .fourContentLeft {
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
      }
      .fourContentRight {
        float: right;
        width: 1100px * $sun;
        height: 460px * $sun;
        margin-left: 30px;
      }
    }
  }
  .el-carousel__indicators
    .el-carousel__indicators--horizontal
    .el-carousel__indicators--outside {
    display: none;
  }
}
// 5层
.five {
  width: 100%;
  height: 1000px * $sun;
  background: #fff;
  display: flex;
  align-items: center;
  // justify-content: center;
  overflow: hidden;
  .fiveBox {
    width: 1400px * $sun;
    height: 627px * $sun;
    margin: auto;
    margin-top: 120px * $sun;
    .fiveBoxTop {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 89px * $sun;
      .fiveBoxTopL {
        margin: 0;
        float: left;
        font-size: 36px * $sun;
        width: 710px * $sun;
        font-weight: 500;
      }
    }
    .fiveBoxBottom {
      width: 100%;
      height: 595px * $sun;
      display: flex;
      justify-content: space-between;
      .headNewsShow {
        width: 1400px * $sun;
        margin: auto;
        width: 480px * $sun;
        height: 480px * $sun;
        display: flex;
        justify-content: center;
        img {
          width: 480px * $sun;
          height: 480px * $sun;
        }
      }
      .fiveBoxBottomL {
        float: left;
        width: 815px * $sun;
        height: 600px * $sun;
        padding-right: 10px * $sun;
        cursor: pointer;
        overflow: hidden;
        .fiveBoxBottomLItem {
          float: left;
          width: 390px * $sun;
          height: 595px * $sun;
          background: #f6f9fe;
          border-radius: 8px * $sun;
          transition: all 0.2s;
          overflow: hidden;
          .fiveBoxBottomLItemImg {
            width: 100%;
            height: 270px * $sun;
            margin-bottom: 27px * $sun;
            overflow: hidden;
          }
          .fiveBoxBottomLItemBox {
            padding: 0 23px * $sun;
            overflow: hidden;
            height: 280px * $sun;
            .fourIcon {
              float: right;
              width: 38px * $sun;
              height: 38px * $sun;
            }
          }
        }
        // 动画
        .fiveBoxBottomLItem:hover p {
          color: #2380e1;
        }
        .fiveBoxBottomLItem:hover img {
          animation: move 0.5s linear forwards;
        }
        .fiveBoxBottomLItem:hover .fiveBoxBottomLImg {
          animation: move 0.5s linear forwards;
        }
        @keyframes move {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }
        .fiveBoxBottomLItem:hover {
          /* 盒子向上移动 */
          transform: translateY(-2px * $sun);
          /* 背景 */
          box-shadow: 5px * $sun 5px * $sun 5px * $sun rgba(19, 19, 20, 0.15);
          // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
        }
        .fiveBoxBottomLItemFloat {
          float: right;
        }
        .fiveBoxBottomLImg {
          width: 100%;
          height: 270px * $sun;
          // margin-bottom: 27px*$sun;
        }
        .fiveBoxBottomLIcon {
          margin: 0;
          margin-bottom: 20px * $sun;
          height: 20px * $sun;
          width: 38px * $sun;
          border-top: 6px * $sun solid #2380e1;
          overflow: hidden;
        }
        .fiveBoxBottomLTitle {
          height: 54px * $sun;
          font-size: 24px * $sun;
          margin: 0;
          margin-bottom: 20px * $sun;
          font-weight: 500;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .fiveBoxBottomLText {
          font-size: 16px * $sun;
          font-weight: 500;
          height: 100px * $sun;
        }
      }
      // 右边
      .fiveBoxBottomR {
        float: right;
        width: 550px * $sun;
        cursor: pointer;
        position: relative;
        .fiveBoxBottomRBtn {
          position: absolute;
          right: 0;
          bottom: 35px * $sun;
          height: 43px * $sun;
          width: 127px * $sun;
          margin: 0;
          font-size: 18px * $sun;
          color: #9b9b9b;
          font-weight: 500;
          border: 2px * $sun solid #9b9b9b;
          line-height: 43px * $sun;
          text-align: center;
        }
        .fiveBoxBottomRBtn:hover {
          color: #2380e1;
        }
        .fiveBoxBottomRItem {
          width: 100%;
          height: 120px * $sun;
          border-bottom: 2px * $sun solid #ebebeb;
          margin-bottom: 21px * $sun;
          p {
            margin: 0;
            float: right;
            width: 380px * $sun;
            font-size: 18px * $sun;
            font-weight: 500;
          }
          .fiveBoxBottomRImg {
            float: left;
            width: 143px * $sun;
            height: 94px * $sun;
            margin-right: 20px * $sun;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .fiveBoxBottomRItem:hover {
          color: #2380e1;
        }
      }
      .fiveBoxBottomR :nth-last-child(1) {
        border-bottom: 0px;
      }
    }
  }
}
// 6层
.six {
  width: 100%;
  height: 1000px * $sun;
  background: url("./index/pcHome/six.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .sixTitle {
    font-weight: 500;
    color: #252b3a;
    font-size: 36px * $sun;
    margin: 0 auto;
    margin-top: 218px * $sun;
    margin-bottom: 195px * $sun;
    text-align: center;
  }
  .sixBox {
    width: 1400px * $sun;
    height: 373px * $sun;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .sixItem {
      margin-bottom: 50px * $sun;
    }
  }
}
</style>
